import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from '@angular/core';

import { CompetencyDTO } from '../../../dtos/competencies.dto';
import {
  CompetencyFilterParams,
  TopicBuilderService,
} from '../../../services/topic-builder/topic-builder.service';
import { CompetencyBuilderStandardAPIResponse } from '../../../types/responses/competency-builder.responses';
import { ModalComponent } from '../modal/modal.component';

@Component({
  selector: 'app-onboarding-topic-competencies-modal',
  standalone: false,
  templateUrl: './onboarding-topic-competencies-modal.component.html',
  styleUrl: './onboarding-topic-competencies-modal.component.scss',
})
export class OnboardingTopicCompetenciesModalComponent implements OnChanges {
  @Input() topic?: CompetencyBuilderStandardAPIResponse;

  @ViewChild('modal') modal: ModalComponent;

  filterParams = {} as CompetencyFilterParams;

  competencies: CompetencyDTO[];

  isLoading = true;

  constructor(private topicBuilderService: TopicBuilderService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['topic']) {
      if (this.topic) {
        this.getCompetencies(this.topic.id);
      }
    }
  }

  getCompetencies(topicId: number) {
    this.isLoading = true;

    this.topicBuilderService.getTopicCompetencies(topicId).subscribe({
      next: (response) => {
        setTimeout(() => {
          this.isLoading = false;
          this.competencies = response.items;
        }, 500);
        if (this.topic) {
          this.modal.config.titleText = `Competencies for: ${this.topic.title}`;
        }
      },
    });
  }

  openModal() {
    this.modal.open();
  }

  closeModal() {
    this.modal.close();
  }
}
